import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SectionLabel, TiltCard } from './Effects';
import { ArrowIcon } from './Icons';
import { SERVER_NEWS } from '../data/news';

export function NewsSection() {
  const navigate = useNavigate();
  const [selectedTag, setSelectedTag] = useState<string>('All');
  const tags = ['All', 'Event', 'Server', 'Portal', 'Update', 'Economy'];

  const filteredNews = selectedTag === 'All' 
    ? SERVER_NEWS 
    : SERVER_NEWS.filter(item => item.tag.toLowerCase() === selectedTag.toLowerCase());

  const formatDate = (isoString: string) => {
    try {
      const d = new Date(isoString);
      return d.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    } catch {
      return isoString;
    }
  };

  return (
    <section id="news" className="news-section section-pad">
      <SectionLabel index="05">DISPATCHES & ARCHIVES</SectionLabel>

      <div className="split-heading" data-reveal>
        <div>
          <h2>The Chronicle.<br /><em>State dispatches & events.</em></h2>
        </div>
        <div>
          <p>
            Official gazettes, sovereign announcements, server milestones, and seasonal events directly from Uge Appage SMP leadership.
          </p>
          <div style={{ marginTop: '1rem' }}>
            <Link to="/news" className="outline-link">
              <span>View All Dispatches Archive</span>
              <ArrowIcon />
            </Link>
          </div>
        </div>
      </div>

      {/* Tag Filter Pills */}
      <div className="news-filter-bar" data-reveal>
        {tags.map(tag => (
          <button
            key={tag}
            type="button"
            className={`news-tag-btn ${selectedTag === tag ? 'active' : ''}`}
            onClick={() => setSelectedTag(tag)}
          >
            <span>{tag === 'All' ? '✦ All Dispatches' : `# ${tag}`}</span>
          </button>
        ))}
      </div>

      {/* News Grid */}
      <div className="news-grid" data-reveal>
        {filteredNews.map((item) => (
          <TiltCard key={item.id} className={`news-card ${item.pinned ? 'pinned-dispatch' : ''}`}>
            <div 
              className="news-card-inner clickable-card"
              onClick={() => navigate(`/news/${item.id}`)}
              style={{ cursor: 'pointer' }}
            >
              <div className="news-card-header">
                <span className={`news-badge badge-${item.tag.toLowerCase()}`}>
                  {item.pinned ? '📌 ' : ''}{item.tag.toUpperCase()}
                </span>
                <time className="news-date" dateTime={item.date}>
                  {formatDate(item.date)}
                </time>
              </div>

              <h3 className="news-card-title">{item.title}</h3>
              <p className="news-card-body">{item.body}</p>

              <div className="news-card-footer">
                <Link to={`/news/${item.id}`} className="news-read-more" onClick={(e) => e.stopPropagation()}>
                  <span>Read Full Dispatch</span>
                  <ArrowIcon />
                </Link>
                {item.readTime && <small className="news-card-readtime">{item.readTime}</small>}
              </div>
            </div>
          </TiltCard>
        ))}
      </div>
    </section>
  );
}
